// TypeScript port of src/pwhlstats/web/team_colors.py.
// Used for the team-colored cell tint in the events table and the team
// badges / draft board / roster cards on the client-side /expansion page.

const PRIMARY: Record<string, string> = {
  BOS: "#154734",
  MIN: "#2E1A47",
  MTL: "#862633",
  NY: "#0C2340",
  OTT: "#CE1126",
  TOR: "#003876",
  SEA: "#00685E",
  VAN: "#8A7A2B",
  // 2026-27 expansion clubs (kept in sync with team_colors.py PRIMARY).
  DET: "#C8102E",
  HAM: "#6B2733",
  LV: "#147A4A",
  SJ: "#E35205",
};

const FALLBACK = "#40464f";

export function teamColor(code: string | null | undefined): string {
  if (!code) return FALLBACK;
  return PRIMARY[code.toUpperCase()] ?? FALLBACK;
}

function hexToRgb(hex: string): [number, number, number] {
  const h = hex.replace(/^#/, "");
  return [
    parseInt(h.slice(0, 2), 16),
    parseInt(h.slice(2, 4), 16),
    parseInt(h.slice(4, 6), 16),
  ];
}

/** Translucent tint of the team color for backgrounds/highlights — mirrors
 *  team_colors.color_soft_for. */
export function teamColorSoft(code: string | null | undefined, alpha = 0.1): string {
  const [r, g, b] = hexToRgb(teamColor(code));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Pick #0d1620 or #ffffff for legibility on top of the team color — mirrors
 *  team_colors.color_contrast_for (WCAG relative luminance, threshold 0.45). */
export function teamColorContrast(code: string | null | undefined): string {
  const [r, g, b] = hexToRgb(teamColor(code));
  const channel = (c: number): number => {
    const v = c / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  };
  const lum = 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
  return lum > 0.45 ? "#0d1620" : "#ffffff";
}
